export const master = {
    id: 'masters',
    title: 'Masters',
    type: 'collapse',
    icon: 'IconAffiliate',
    children: [
        {
            id: 'admin_users.view_implementerdetails',
            title: 'Implementers',
            type: 'item',
            url: '/implementer_list',
            icon: 'IconAffiliate'
        },
        {
            id: 'masters.view_tblclient',
            title: 'Clients',
            type: 'item',
            url: '/client_list',
            icon: 'IconBriefcase'
        },
        {
            id: 'masters.view_tblvendor',
            title: 'Sub Vendors',
            type: 'item',
            url: '/vendor_list',
            icon: 'IconBuildingWarehouse'
        }
    ]
};